import { _ } from "../../core/polyglot/polyglot.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import accountingDocument from "../shared/accountingDocument.js";
import CompanyTransitionBalance from "../../models/accounting/CompanyTransitionBalance.js";
import companyWidget from "./companyWidget.js";
import session from "../../core/session.js";

/**
 * Document for comparing the company balance for a specific period. See the help text for more information.
 */
function companyDocument(spec, my) {
	my ||= {};
	const that = accountingDocument(spec, my);

	that.title = _("The Company");

	that.documentId = "company";

	that.help = function () {
		return [
			{
				title: _("The Company"),
				content: _(
					"The company page gives someone without accounting expertise the same overview picture of a company’s financial position as an accountant get from the Balance Sheet. The financial position coming into a period and the financial position leaving the same period.",
				),
			},
			{
				title: _("Changes of assets"),
				content: _(
					"The stacked barplot graphs on this page shows snapshots of the size of a company’s assets as well as how these assets are financed in the beginning of and at the end of the same period.",
				),
				element: "company-balance-chart",
			},
			{
				title: _("Changes of liabilities"),
				content: _(
					"The blue part of the bar visualize how much of the assets are financed by liabilities and the yellow part visualize how much of the assets are financed by equity capital (Owners Part).",
				),
				element: "company-balance-chart",
			},
			{
				title: _("Chart legend"),
				content: _(
					"By clicking on the entities below the graph you will be presented with detailed information.",
				),
				element: "company-balance-legend",
			},
		];
	};

	that.subtitle = _("Changes during {period}", {
		period: session.getPeriod().toSmartString(),
	});

	my.companyTransitionBalanceRepository = makeMonitorRepository({
		model: CompanyTransitionBalance,
		route: "/Accounting2/Company/#companyId/CompanyTransitionBalance/#periodId",
		defaultFilters: { companyId: session.getCompany().getLegacyId() },
		antiForgeryToken: session.getAntiForgeryToken(),
	});

	my.companyWidget = companyWidget();

	that.showCurrentPeriod = async function () {
		const period = session.getPeriod();

		const companyTransitionBalance =
			await my.companyTransitionBalanceRepository.get({
				filter: { periodId: period.toString() },
			});

		my.companyWidget.show(companyTransitionBalance);
	};

	that.isActionsMenuMobileOnly = function () {
		return true;
	};

	my.renderContentOn = function (html) {
		html.h2(_("Changes of assets and liabilities during period"));
		html.render(my.companyWidget);
	};

	return that;
}

export default companyDocument;
